import { getCurrentOrg } from '.';
import { ConversationBillingControllerService } from '../services/conversations-billing';
import type { AgentAnalyticsResponse } from '../services/conversations-billing/models/AgentAnalyticsResponse';

export type AnalyticsDataPayload = {
  agentId: string;
  from: string;
  to: string;
  period?: string;
};

export const getAgentAnalytics = async (
  payload: AnalyticsDataPayload
): Promise<AgentAnalyticsResponse> => {
  const orgContext = getCurrentOrg();

  return await ConversationBillingControllerService.getAgentAnalytics(
    orgContext,
    payload.agentId,
    payload.from,
    payload.to
  );
};
